import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { ParametrosService } from './parametros.service';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private userLogIn = new Subject<boolean>();

  constructor(private _parametro: ParametrosService) {
    this.setUserLogIn(false);
  }

  setUserLogIn(userLogIn: boolean) {
    this.userLogIn.next(userLogIn);
  }

  saveUser(data: any) {
    sessionStorage.setItem('user', JSON.stringify(data));
    this.setUserLogIn(true);
  }

  getUser() {
    return JSON.parse(sessionStorage.getItem('user'));
  }

  setToken(token: string) {
    let json = JSON.parse(sessionStorage.getItem('user'));
    json.token = token;
    sessionStorage.setItem('user', JSON.stringify(json));
  }

  getToken() {
    let json = JSON.parse(sessionStorage.getItem('user'));
    return json?.token;
  }

  isUserLogIn(): Observable<boolean> {
    return this.userLogIn.asObservable();
  }

  async deleteUser() {
    if (this.getToken()) {
      try {
        await this._parametro.logout().toPromise();
      } catch (e) {
        console.log(e);
      }
    }
    sessionStorage.clear();
    //console.clear();
    this.setUserLogIn(false);
  }

  setIdSolicitud(idSolicitud: number) {
    let json = JSON.parse(sessionStorage.getItem('user'));
    json['idSolicitud'] = idSolicitud;
    this.saveUser(json);
  }
}
